<template>
  <div class="router-layout">
    <router-view></router-view>
  </div>
</template>